declare namespace $ {

	type $shm_check_list__options_shm_hitalama_map_widget_float_chart_filter_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart_filter['filter_options'] >
		,
		ReturnType< $shm_check_list['options'] >
	>
	type $shm_check_list__value_shm_hitalama_map_widget_float_chart_filter_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart_filter['filter_options_checked'] >
		,
		ReturnType< $shm_check_list['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_chart_filter_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart_filter['field_name'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_chart_filter_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_chart_filter['Filter_options'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_chart_filter_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $shm_hitalama_map_widget_float_chart_filter extends $shm_hitalama_map_widget_float {
		field_name( ): string
		filter_options( ): readonly(any)[]
		filter_options_checked( next?: readonly(any)[] ): readonly(any)[]
		Filter_options( ): $shm_check_list
		Field( ): $mol_form_field
		Form( ): $mol_list
		content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=filter.view.tree.d.ts.map